<template>
    <div>
        <template v-if="crud_branches === true">
            <div class="container">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left">Edit Branch</h1>
                </div>
                <div class="global-main">
                    <form @submit.prevent="editBranchData">
                        <div class="tab-content-inner">
                            <div class="form-group">
                                <label> Name </label>
                                <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                                <has-error :form="form" field="name"></has-error>
                            </div>
                        </div>
                        <div class="form-group">
                            <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                            <router-link to="/branches" class="btn btn-primary float-right mr-2">Cancel</router-link>
                        </div>
                    </form>
                </div>
            </div>
        </template>
        <template v-if="crud_branches === null"><preLoader></preLoader></template>
        <template v-if="crud_branches === false"><notAllowed></notAllowed></template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    name : '',
                }),
                crud_branches : null,
            };
        },
        methods: {
            editBranchData() {
                this.$Progress.start();
                this.form.put('/api/updateBranch')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success','Branch update successfully');
                            this.$router.push('/branches');
                        }else{
                            this.$Progress.fail();
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                        console.log(err);
                    });
            },
            getBranchData(){
                axios.get('/api/editBranch/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.form.id = res.data.id;
                        this.form.name = res.data.name;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                });
            }
        },
        mounted() {
            this.$Progress.start();
            this.can('crud_branches').then(result=>{
                this.crud_branches = result.crud_branches;
            }).then(result=>{
                if(this.crud_branches === true){
                    this.getBranchData();
                }
            });
        },
        created() {
            //
        }
    }
</script>